import { render, staticRenderFns } from "./FooterContainer.vue?vue&type=template&id=ddcc8afc&scoped=true"
import script from "./FooterContainer.vue?vue&type=script&lang=js"
export * from "./FooterContainer.vue?vue&type=script&lang=js"
import style0 from "./FooterContainer.vue?vue&type=style&index=0&id=ddcc8afc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcc8afc",
  null
  
)

export default component.exports